import Vue from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

import * as Sentry from '@sentry/vue';

import {
  clearSearchAuthHeader,
  isFirebaseAuthExpiredError,
  setSearchAuthHeader,
} from '@/utils/searchAuth.util';

import App from './App';
import router from './router';
import store from './store';

import { SENTRY_IGNORE_ERRORS } from '@cardladder/shared/constants';
import eventBus from '@cardladder/shared/utils/bus.util';

import '@cardladder/shared/scss/global.scss';
import './components';

Vue.config.productionTip = false;
Vue.prototype.$bus = eventBus;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://fdc5247bec444ea0bb1d8129ccd17c1b@o393801.ingest.us.sentry.io/5243282',
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
  });
}

const authDomain = window.location.hostname === 'app.cardladder.com'
  ? 'app.cardladder.com'
  : 'cardladder-71d53.firebaseapp.com';

firebase.initializeApp({
  apiKey: 'AIzaSyBqbxgaaGlpeb1F6HRvEW319OcuCsbkAHM',
  authDomain,
  databaseURL: 'https://cardladder-71d53.firebaseio.com',
  projectId: 'cardladder-71d53',
  storageBucket: 'cardladder-71d53.appspot.com',
  messagingSenderId: '596818502949',
  appId: '1:596818502949:web:25bbe6643409101bd8e6cc',
});

firebase.firestore().settings({ ignoreUndefinedProperties: true });

// if (process.env.NODE_ENV === 'development') {
//   firebase.functions().useEmulator('localhost', 5001);
// }

let app = '';

firebase.auth().onAuthStateChanged((firebaseUser) => {
  if (!app) {
    store.dispatch('boot', firebaseUser)
      .then(() => {
        app = new Vue({
          router,
          store,
          render: (h) => h(App),
        }).$mount('#app');
      });
  }
});

function syncSearchAuthHeader(firebaseUser, forceRefresh = false) {
  if (firebaseUser) {
    setSearchAuthHeader(forceRefresh).catch((e) => {
      if (!isFirebaseAuthExpiredError(e)) {
        console.warn('setSearchAuthHeader failed', e);
      }
    });
  } else {
    clearSearchAuthHeader();
  }
}

firebase.auth().onIdTokenChanged((firebaseUser) => {
  syncSearchAuthHeader(firebaseUser);
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && firebase.auth().currentUser) {
    syncSearchAuthHeader(firebase.auth().currentUser, true);
  }
});
